import { Injectable } from '@angular/core';

export type ToastType = 'success' | 'danger' | 'warning' | 'info';

declare global {
    interface Window {
        bootstrap?: any;
    }
}

@Injectable({ providedIn: 'root' })
export class BootstrapToastService {

    private activeToasts = new Set<string>();

    show(
        message: string,
        type: ToastType = 'info',
        title = 'Message',
        delay = 5000
    ) {
        const signature = `${type}|${title}|${message}`;

        if (this.activeToasts.has(signature)) {
            return;
        }

        this.activeToasts.add(signature);

        const toastEl = document.createElement('div');
        toastEl.className = `toast align-items-center text-bg-${type} border-0`;
        toastEl.role = 'alert';
        toastEl.ariaLive = 'assertive';
        toastEl.ariaAtomic = 'true';

        toastEl.innerHTML = `
          <div class="d-flex">
            <div class="toast-body">
              <strong class="d-block mb-1">${title}</strong>
              ${message}
            </div>
            <button type="button"
              class="btn-close btn-close-white me-2 m-auto"
              data-bs-dismiss="toast"
              aria-label="Close">
            </button>
          </div>
        `;

        this.getContainer().appendChild(toastEl);

        const toast = new window.bootstrap.Toast(toastEl, { delay });
        toast.show();

        toastEl.addEventListener('hidden.bs.toast', () => {
            this.activeToasts.delete(signature);
            toastEl.remove();
        });
    }

    private getContainer(): HTMLElement {
        let container = document.getElementById('bootstrap-toast-container');

        if (!container) {
            container = document.createElement('div');
            container.id = 'bootstrap-toast-container';
            container.className = 'toast-container position-fixed top-0 end-0 p-3';
            container.style.zIndex = '12000000000';
            document.body.appendChild(container);
        }

        return container;
    }
}
